module.exports = __webpack_public_path__ + "static/landing-page-2-466df67e38574d32151fa751602d28a2.png";